var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"mt-3",attrs:{"show":"","variant":"dark","data-qa":"error notice"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('error'))+":")]),_vm._v(" "+_vm._s(_vm.error)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }